export default "__VITE_ASSET__BvrW7OWI__"